<template>
  <q-dialog persistent v-model="isOpen">
    <q-card style="max-width: 600px; width: 100%">
      <q-form @submit.prevent="createBatch">
        <div class="q-pa-md">
          <div class="row q-col-gutter-md">
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <q-select
                outlined
                color="grey-7"
                label-color="grey-7"
                label="Type*"
                :options="types"
                v-model="type"
                emit-value
                map-options
                lazy-rules
                :rules="[val => (val !== null && val !== '') || 'Please select a type']"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <div class="file-input">
                <input ref="fileInput" required accept=".xlsx, .xls" @change="selectFile" type="file" class="file" />
                <label for="file">
                  <q-icon class="q-mx-sm" name="fas fa-upload" size="20px" color="grey-7"></q-icon>
                  File*
                  <span class="file-name"></span
                ></label>
              </div>
              <p>{{ fileName }}</p>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Company*</span>
              <q-select
                outlined
                color="grey-7"
                label-color="grey-7"
                label="Company"
                :options="companies"
                v-model="company"
                emit-value
                map-options
                lazy-rules
                :rules="[val => (val !== null && val !== '') || 'Please select a company']"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-12">
              <div class="mt-5 flex-end q-gutter-xs">
                <q-btn color="grey-7" @click="isOpen = false">CANCEL</q-btn>
                <q-btn :loading="false" label="Save" type="submit" color="positive">
                  <template v-slot:loading>
                    <q-spinner-facebook />
                  </template>
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
export default {
  props: {
    updateTable: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      file: null,
      type: null,
      company: null,
      types: [
        {
          label: 'Assumption',
          value: 'assumption'
        },
        {
          label: 'Lease',
          value: 'lease'
        },
        {
          label: 'Flooring',
          value: 'flooring'
        },
        {
          label: 'Finance',
          value: 'finance'
        }
      ],
      companies: [],
      fileName: ''
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.vehicle.excelModal
      },
      set(val) {
        this.$store.commit('vehicle/OPEN_EXCEL_MODAL', val)
      }
    }
  },
  created() {
    this.getCompanies()
  },
  methods: {
    async getCompanies() {
      const { data } = await axios.get('/companies')
      const arr = data.data
      this.companies = arr.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
    },
    selectFile() {
      this.file = this.$refs.fileInput.files[0]
      this.fileName = this.file.name
    },
    async createBatch() {
      try {
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('type', this.type)

        formData.append('company', this.company)

        const { data } = await axios.put('/vehicle-finance/batch', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: localStorage.getItem('token')
          }
        })
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.isOpen = false
        this.type = null
        this.company = null
        this.file = null
        this.updateTable()
      } catch (error) {
        this.$q.notify({
          message: error.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.type = null
        this.company = null
        this.file = null
      }
    }
  }
}
</script>
<style scoped>
.file-input {
  position: relative;
  height: 56px;
  width: 100%;
  cursor: pointer;
}
.file {
  opacity: 0;
  width: 100%;
  height: 56px;
  left: 0;
  top: 0;
  position: absolute;
  z-index: 1000;
  outline: none;
  cursor: pointer;
}
.file-input label {
  display: block;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.24);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease-out;
  cursor: pointer;
}
input:hover + label {
  cursor: pointer;
  background: rgb(189, 189, 189, 0.2);
}
</style>
